import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from '../../images/ordinationen/bg_2018-2.png';

const Ordinationen = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Ordinationen </h1>
                    
                    <h3> Wien </h3>
                    <table>
                        <tr>
                            <td><strong>PLZ / Ort:</strong></td>
                            <td>1150 Wien</td>
                        </tr>
                        <tr>
                            <td><strong>Straße:</strong></td>
                            <td>Kranzgasse 22 / Hoftrakt</td>
                        </tr>
                        <tr>
                            <td><strong>Tel.:</strong></td>
                            <td>+43 1 892 17 17</td>
                        </tr>
                        <tr>
                            <td><strong>Fax:</strong></td>
                            <td>+43 720 72 00 111</td>
                        </tr>
                        <tr>
                            <td><strong>Kassen:</strong></td>
                            <td>alle Kassen</td>
                        </tr>
                        <tr>
                            <td><strong>Ordinationszeiten:</strong></td>
                            <td>
                                Mo 9–13 und 15–19<br/>
                                Di 8–13<br/>
                                Mi 9–14<br/>
                                Do 8–13 und 14–16<br/>
                                und nach Vereinbarung per <a href="/homepage/#/termine">Internet</a> oder Telefon
                            </td>
                        </tr>
                    </table>
                    <br /><br />


                    <h3> Payerbach - NÖ </h3>
                    <p className="page-text"> Bezirk Neunkirchen </p>
                    
                    <table>
                        <tr>
                            <td><strong>PLZ / Ort:</strong></td>
                            <td>2650 Payerbach</td>
                        </tr>
                        <tr>
                            <td><strong>Straße:</strong></td>
                            <td>Mühlhofstrasse 26</td>
                        </tr>
                        <tr>
                            <td><strong>Tel.:</strong></td>
                            <td>+43 664 449 72 23</td>
                        </tr>
                        <tr>
                            <td><strong>Fax:</strong></td>
                            <td>+43 2666 527 84</td>
                        </tr>
                        <tr>
                            <td><strong>Kassen:</strong></td>
                            <td>Privatordination – keine Kassen</td>
                        </tr>
                        <tr>
                            <td><strong>Ordinationszeiten:</strong></td>
                            <td>
                            Terminvereinbarung per Telefon erforderlich<br />
                            <strong>ACHTUNG!</strong> Sie werden gelegentlich in die Wiener Ordination telephonisch umgeleitet.<br />
                            Sagen Sie einfach dazu, dass Sie einen Termin in Payerbach benötigen!
                            </td>
                        </tr>
                    </table>


                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Ordinationen;